import styled from '@emotion/styled';

export const StyledPageTitle = styled.h2``;

export const StyledPageSubTitle = styled.h3`
  font-size: 35px;
`;

export const StyledPaperSubTitle = styled.h4`
  font-size: 25px;
`;
